import { EventMeta } from '../../../interfaces/meta.interface';

const sendAs: EventMeta = {
    title: 'Message Sent Using SendAs',
    default: {
        description: 'Message Sent Using SendAs',
        longDescription: 'A message was sent as if it came from the mailbox owner.',
        severity: 'info',
    },
};

export default sendAs;
